import { ILearningChunk } from './learning-chunk';
import { IUnit } from './unit';
import { IUser } from './user';

export enum UnitSectionTypes {
    learning = 'learning',
    practice = 'practice',
}

export enum UnitSectionTerminologyValues {
    lay = 'lay',
    model = 'model',
}

export interface IUnitSectionExerciseParam {
    type: string,
    skill: string,
    terminology: string,
}

export interface IUnitSection {
    uid: string,
    name: string,
    description: string,
    index: number,
    type?: UnitSectionTypes,
    episodeCount?: number,
    available?: boolean,
    deleted?: boolean,
    edited?: boolean,
    multPerspectiveCompatible?: boolean,
    exerciseParams?: IUnitSectionExerciseParam[],

    unit?: IUnit,
    learningChunks?: ILearningChunk[],
    completed_by?: IUser[],
}
